import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfPinTapVoiceControl',
  standalone: false,
})
export class TypeOfPinTapVoiceControlPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.PIN_TAP_VOICE_CONTROL_TYPE_OFF:
        type = this.translate.instant('展示情報の音声を自動再生しない');
        break;
      case AppConst.PIN_TAP_VOICE_CONTROL_TYPE_ON:
        type = this.translate.instant('展示情報の音声を自動再生する');
        break;
    }
    return type;
  }

}


